import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
const [
  LIST_SALES_ESTIMATE,
  LIST_SALES_ESTIMATE_SUCCESS,
  LIST_SALES_ESTIMATE_FAILURE,
] = createRequestActionTypes('chance/LIST_SALES_ESTIMATE');

export const listSalesEstimate = createAction(
  LIST_SALES_ESTIMATE,
  (searchData) => ({ salesType: 'S', searchData }),
);
const listSalesEstimateSaga = createRequestSaga(
  LIST_SALES_ESTIMATE,
  projectApi.getEstimateFiles,
);

const UNLOAD_SALES_ESTIMATE = 'chance/UNLOAD_SALES_ESTIMATE';
export const unloadSalesEstimate = createAction(UNLOAD_SALES_ESTIMATE);

const SET_SALES_ESTIMATE_FITERS = 'chance/SET_SALES_ESTIMATE_FITERS';
export const setSalesEstimateFilters = createAction(
  SET_SALES_ESTIMATE_FITERS,
  (filters) => filters,
);

const RESET_SALES_ESTIMATE_FILTERS = 'chance/RESET_SALES_ESTIMATE_FILTERS';
export const resetSalesEstimateFilters = createAction(
  RESET_SALES_ESTIMATE_FILTERS,
);

export function* salesEstimateSaga() {
  yield takeLatest(LIST_SALES_ESTIMATE, listSalesEstimateSaga);
}

const initialState = {
  files: null,
  error: null,
  defaultFilters: {
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: null,
    searchEndDt: null,
  },
};

const SalesEstimate = handleActions(
  {
    [LIST_SALES_ESTIMATE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.qteUuid,
        qteUuid: file.qteUuid,
        prjUuid: file.prjUuid,
        prjNo: file.prjNo,
        cstNm: file.cstNm,
        prjTyp: file.prjTyp,
        qtePartnerUuid: file.qtePartnerUuid,
        qtePartnerNm: file.qtePartnerNm,
        vendorCmpNm: file.vendorCmpNm,
        qteCrtNm: file.qteCrtNm,
        qteRegDt: file.qteRegDt,
        qteCrtDt: file.qteCrtDt,
      })),
      error: null,
    }),
    [LIST_SALES_ESTIMATE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_SALES_ESTIMATE]: () => initialState,
    [RESET_SALES_ESTIMATE_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_SALES_ESTIMATE_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default SalesEstimate;
